import React, {useState} from 'react';
import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import appConfig from '../../../../app-config';

const ChildLocationName = styled.div`
  display: flex;
  font-size: 40px;
  font-weight: 600;
  margin: auto;
  margin-left: 15px;
  padding-top: 30px;
  height: 100%;
`;

const Logo = styled.img`
  width: ${props => props.theme.logoWidth};
  cursor: pointer;
  margin-top: 5px;
  @media (max-width: 1200px) {
    margin-top: ${props => props.theme.logoMobileMargin};
  }
`;

function MenuSearch(props) {
  const {currentLocation, searchProduct} = props;
  const {selectedChild} = currentLocation;

  const [search, setSearch] = useState('');

  const handleProductSearch = ev => {
    setSearch(ev.target.value);
    searchProduct(ev.target.value);
  };

  return (
    <div
      style={{
        marginTop: '5px',
        marginLeft: 'auto',
        margin: '0 5%',
      }}
    >
      <div style={{display: 'flex', flexDirection: 'row'}}>
        <div>
          <Logo
            src={selectedChild ? selectedChild.image_url : null}
            height="120px"
          />
        </div>
        <ChildLocationName>
          {selectedChild ? selectedChild.name : null}
        </ChildLocationName>
      </div>
      <div>
        <TextField
          style={{borderRadius: 0, width: '100%', marginBottom: '10px'}}
          variant="outlined"
          size="small"
          value={search}
          onChange={ev => handleProductSearch(ev)}
          placeholder={`Search ${selectedChild ? selectedChild.name : null}`}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <i className="fas fa-search" />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </div>
  );
}

export default MenuSearch;
